import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import BootstrapVue from 'bootstrap-vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import AmplifyPlugin from 'aws-amplify-vue'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/apop.css'

Amplify.configure({
  Auth: {
    region: 'us-east-2',
    // Apop_ID_Pool
    identityPoolId: 'us-east-2:d6baab64-5972-496d-bf5f-c21f3b367f72',
    // ApopPool2
    userPoolId: 'us-east-2_75H6JPAsl',
    // ApopPool2 - ApopWebClient
    userPoolWebClientId: '7eohcdaq5mum42d1eljfhrlil5'
  },
  Storage: {
    AWSS3: {
      bucket: 'audio.apoplectic.net',
      region: 'us-east-2'
    }
  }
})

Vue.use(BootstrapVue, AmplifyPlugin, AmplifyModules)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.config.productionTip = false

extend('passwordConfirm', {
  validate: (value, { other }) => value === other,
  message: 'The password fields do not match.',
  params: [{ name: 'other', isTarget: true }]
})

Vue.filter('displayPhoneNumber', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.substr(2, 3) + '-' + value.substr(5, 3) + '-' + value.substr(8, value.length)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
